import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-next.png'

const NextBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default NextBtn
